import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './NotebookAddSourcePopup.css';
import NotebookLang from './NotebookLang.json';
import Dropzone from 'react-dropzone';

class NotebookAddSourcePopup extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookID: 0,
			notebookJsonObj: null,
			uploadInProgressYN: false,
			fileIndex: -1,
			fileArray: [],
		}

		this.onDrop = async (files) => {

			this.state = {
				fileArray: [],
			};

			var len = files.length;
			
			if (len < 1) {
				this.props.showToast("ERROR - You must select at least one file.");
				return;
			}

			var i;
			var oneFile;
			var sizeBytes;
			var filenameExt;
			var results;
			var fileExt;
			var itemObj;
			var fileArray = [];
			
			for(i=0; i<len; i++) {

				oneFile = files[i];
				sizeBytes = oneFile.size;
				filenameExt = oneFile.name;
				fileExt = this.getExtFromFilename(filenameExt);

				if ((fileExt !== "pdf") && (fileExt !== "docx") && (fileExt !== "xlsx") && (fileExt !== "xls")) {
					var toastMessage = this.props.getLang(NotebookLang, "addSourceFileTypeError");
					this.props.showToast(toastMessage);
					return;
				}
				
				itemObj = {};
				itemObj.file = oneFile;
				itemObj.filenameExt = filenameExt;
				itemObj.sizeBytes = sizeBytes;
				itemObj.uploadedYN = false;
				
				fileArray.push(itemObj);
			}
			
			this.setState({
				fileArray: fileArray
			});
			
			this.setState({
				uploadInProgressYN: true,
			});
			
			var notebookID = this.state.notebookID;
			var notebookJsonObj = this.state.notebookJsonObj;
			var storageID = notebookJsonObj.storageID;
			var companyID = this.props.companyID;
			var userID = this.props.userID;
			var fullName = this.props.fullName;

			for(i=0; i<len; i++) {
				itemObj = fileArray[i];
				await this.serverUploadFile(notebookID, storageID, companyID, userID, fullName, fileArray, i);
			}

			this.setState({
				uploadInProgressYN: false,
				fileIndex: -1,
			});
			
			this.onPopUpClosed();
			this.props.refreshData();
		};
	}
		
	async componentDidMount() {
	}

	async componentDidUpdate() {

		var notebookID1 = this.state.notebookID;
		var notebookID2 = this.props.notebookID;
		
		if (notebookID2 === 0) {
			return;
		}

		if (notebookID1 === notebookID2) {
			return;
		}

		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID2);
		var title = notebookJsonObj.title;
		this.setState({
			notebookJsonObj: notebookJsonObj,
			title: title,
			notebookID: notebookID2,
		});
	}

	getExtFromFilename(filename) {
		var ext = filename.substr(filename.lastIndexOf('.') + 1);
		return ext.toLowerCase();
	}

	onPopUpClosed() {
		this.props.setNotebookAddSourcePopupYN(false);
	}

	async serverUploadFile(notebookID, storageID, companyID, userID, userFullName, fileArray, index) {
		
		this.setState({
			fileIndex: index,
		});

		var itemObj = fileArray[index];
		var filenameExt = itemObj.filenameExt;
		var file = itemObj.file;

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/uploadfile?notebookid=" + notebookID;
		url = url + "&storageid=" + encodeURIComponent(storageID);
		url = url + "&filename=" + encodeURIComponent(filenameExt);
		url = url + "&companyid=" + companyID;
		url = url + "&userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		
		var formData = new FormData()
		formData.append('file', file)

		var responseText = "";
		
		try {
			var res = await fetch(url, {
				method: 'POST',
				body: formData
			});

			responseText = await res.text();
		} catch (err) {
		}
		
		if (responseText === "") {
			this.props.showToast("ERROR - Unknown error occured");
			return;
		}

		fileArray[index].uploadedYN = true;
		this.setState({
			fileArray: fileArray,
		});

		return responseText;
	}

	renderUploadInProgress() {

		var uploadInProgressYN = this.state.uploadInProgressYN;
		if (!uploadInProgressYN) {
			return null;
		}
		
		var fileIndex = this.state.fileIndex;
		if (fileIndex === -1) {
			return;
		}
		
		var fileArray = this.state.fileArray;
		var len = fileArray.length;
		var itemObj = fileArray[fileIndex];
		var filenameExt = itemObj.filenameExt;
		var text1 = (fileIndex + 1) + "/" + len + " - " + filenameExt;
		
		return (
			<div className="NotebookAddSourcePopupUploadInProgressContainer">
				<div>{this.props.getLang(NotebookLang, "fileUploadInProgress")}: {text1}</div>
				<div style={{height: "10px"}}></div>
			</div>
		);
	}
	
	onClickCancelButton() {
		this.onPopUpClosed();
	}
	
	onClickPasteTextButton() {
		this.onPopUpClosed();
		this.props.setNotebookPasteTextPopupYN(true);
	}
	
	renderDropzone() {

		var uploadInProgressYN = this.state.uploadInProgressYN;
		if (uploadInProgressYN) {
			return null;
		}
		
		return (
			<Dropzone onDrop={this.onDrop}>
			{({getRootProps, getInputProps}) => (
			  <section>
				<div {...getRootProps({className: 'dropzone'})}>
				  <input {...getInputProps()} />
				  <div className="NotebookAddSourcePopupDropzoneContainer">
				    {this.props.getLang(NotebookLang, "dropzoneMessage")}
				  </div>
				</div>
				<div style={{height: "15px"}}></div>
			  </section>
			)}
			</Dropzone>
		);
	}
	
	renderPasteText() {
		return (
			<div className="NotebookAddSourcePopupPasteTextContainer">
				<div>or</div>
				<div style={{height: "20px"}}></div>
				<button className="ViewSaveButton" onClick={() => this.onClickPasteTextButton()}>{this.props.getLang(NotebookLang, "pasteText")}</button>
				<div style={{height: "30px"}}></div>
			</div>
		);
	}
	
	renderContent() {

		var uploadInProgressYN = this.state.uploadInProgressYN;
		
		return (
			<div className="NotebookAddSourcePopupTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="NotebookAddSourcePopupTitle">{this.props.getLang(NotebookLang, "addSources")}</div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "20px"}}></div>
				{this.renderUploadInProgress()}
				<div style={{height: "20px"}}></div>
				<div>{this.renderDropzone()}</div>
				<div style={{height: "20px"}}></div>
				<div>{this.renderPasteText()}</div>
				{!uploadInProgressYN && (
					<div className="ViewContainerButtons2">
						<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(NotebookLang, "close")}</button>
					</div>
				)}
				<div style={{height: "20px"}}></div>				
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		return (
			<Popup
				className="notebook-add-source-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default NotebookAddSourcePopup;


